import __var_0__ from '@stdlib/vendor/debug.js';
import __var_1__ from '@stdlib/plot/sparklines/unicode/column';
import __var_2__ from '@stdlib/plot/sparklines/unicode/line';
import __var_3__ from '@stdlib/plot/sparklines/unicode/tristate';
import __var_4__ from '@stdlib/plot/sparklines/unicode/up-down';
import __var_5__ from '@stdlib/plot/sparklines/unicode/win-loss';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var logger = __var_0__;
var ColumnChart = __var_1__;
var LineChart = __var_2__;
var TristateChart = __var_3__;
var UpDownChart = __var_4__;
var WinLossChart = __var_5__;


// VARIABLES //

var debug = logger( 'sparkline:unicode:render' );


// MAIN //

/**
* Renders a chart.
*
* @private
* @returns {string} rendered chart
*/
function render() {
	/* eslint-disable no-invalid-this */
	var out;

	debug( 'Rendering...' );

	switch ( this._type ) { // eslint-disable-line default-case
	case 'column':
		out = ColumnChart.prototype._render.call( this ); // eslint-disable-line no-underscore-dangle
		break;
	case 'line':
		out = LineChart.prototype._render.call( this ); // eslint-disable-line no-underscore-dangle
		break;
	case 'tristate':
		out = TristateChart.prototype._render.call( this ); // eslint-disable-line no-underscore-dangle
		break;
	case 'up-down':
		out = UpDownChart.prototype._render.call( this ); // eslint-disable-line no-underscore-dangle
		break;
	case 'win-loss':
		out = WinLossChart.prototype._render.call( this ); // eslint-disable-line no-underscore-dangle
		break;
	}

	this.emit( 'render', out );
	return out;
}


// EXPORTS //
export default render;
